<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: 'Feature' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه ویژگی ها
        </b-button
        >
      </router-link>
    </b-col>

    <form @submit.prevent>

      <div class="row">

        <form-group class="col-lg-6" :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام</label>

            <input v-model="form.name" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="col-lg-6" :validations="$v.form.public_name">
          <div slot-scope="{ errors, invalid }">
            <label>نام عمومی</label>
            <input v-model="form.public_name" type="text" class="form-control">
            <form-errors-manager :errors="errors"/>
          </div>

        </form-group>

      </div>

      <div class="row pt-3">

        <div class="col-lg-6">
          <form-group :validations="$v.form.type">
            <div slot-scope="{ errors, invalid }">
              <label>نوع</label>
              <div>
                <b-form-select v-model="form.type" :disabled="pageStatus" :options="types"></b-form-select>
              </div>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div class="col-lg-6">
          <form-group :validations="$v.form.feature_attributes">
            <div slot-scope="{ errors, invalid }">
              <label>خصوصیات ویژگی</label>
              <div class="">
                <b-input-group dir="ltr">
                  <b-form-input dir="rtl" class="text-right" v-model="feature_attributes"
                                @keyup.enter="addItem"></b-form-input>
                  <b-input-group-append>
                    <b-button @click="addItem" type="button" variant="info">اضافه کردن</b-button>
                  </b-input-group-append>
                </b-input-group>

                <div class="items">
                  <div class="item mt-2" v-for="(item, index) in form.feature_attributes">
                    <div class="input-group" dir="ltr">
                      <div class="input-group-prepend" v-if="pageStatus">
                        <button @click="updateItem(index)" class="btn btn-secondary" type="button">
                          <b-icon icon="check-circle"></b-icon>
                        </button>
                      </div>

                      <input dir="rtl" v-model="form.feature_attributes[index].value" type="text"
                             class="form-control text-right">

                      <div class="input-group-append">
                        <button @click="removeItem(index)" class="btn btn-secondary" type="button">
                          <b-icon icon="x"></b-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>


      </div>


      <b-col class="text-center">
        <b-btn variant="purple" pill @click="onSubmit" class=" col-lg-8 my-5 ">
          ثبت
        </b-btn>
      </b-col>

    </form>
  </b-container>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import router from "@/router";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";


export default {
  name: "CreateFeatureForm",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      feature_attributes: '',
      types: [
        {value: 'text', text: 'متن'},
        {value: 'list', text: 'لیست'},
      ],
      form: {
        id: '',
        name: '',
        public_name: '',
        type: 'text',
        feature_attributes: [],
      },
    }
  },
  props: ['functionType', 'title'],
  validations: {
    form: {
      name: {required},
      public_name: {required},
      type: {required},
      feature_attributes: {required},
    },
  },
  computed: {
    pageStatus() {
      // below condition define we are in update mode or not
      return router.currentRoute.params.id !== undefined
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = Object.assign({}, this.form)
        if (this.functionType === 'update') {
          if (form.type === 'list') {
            form.feature_attributes = this.makeAttributeArrayForSubmit(form.feature_attributes)
            this.$store.dispatch('Feature/updateFeature', form)
          } else {
            this.$store.dispatch('Feature/updateFeature', form)
          }

        } else {
          form.feature_attributes = this.makeAttributeArrayForSubmit(form.feature_attributes)
          this.$store.dispatch('Feature/createFeature', form);
        }

      }
    },
    addItem() {
      if (this.feature_attributes.trim().length === 0) {
        return
      }
      if (this.form.type == 'text' && this.form.feature_attributes.length == 1) {
        toast('خطا', 'برای ویژگی های متنی بیشتر از یک مورد نمیتوان اضافه کرد', 'danger')
        return;
      }

      if (this.pageStatus) {
        const form = {
          feature_id: this.form.id,
          value: this.feature_attributes,
        }
        this.$store.dispatch('Feature/createFeatureAttribute', form).then((res) => {
          this.form.feature_attributes.push(res)
        })
      } else {
        this.form.feature_attributes.push({value: this.feature_attributes})
      }

      this.feature_attributes = ''

    },
    removeItem(index) {
      if (this.pageStatus) {
        const feature_attribute = this.form.feature_attributes[index];
        const form = {
          feature_attribute_id: feature_attribute.id,
        }
        this.$store.dispatch('Feature/removeFeatureAttribute', form)
      }
      this.form.feature_attributes.splice(index, 1)
    },
    makeAttributeArrayForSubmit() {
      let attributes = []
      this.form.feature_attributes.forEach((item, index) => {
        attributes.push(item.value)
      })
      return attributes
    },
    updateItem(index) {
      const feature_attribute = this.form.feature_attributes[index];
      const form = {
        feature_id: feature_attribute.feature_id,
        feature_attribute_id: feature_attribute.id,
        value: feature_attribute.value,
      }
      this.$store.dispatch('Feature/updateFeatureAttribute', form)
    }
  },
  mounted() {
    if (this.pageStatus) {
      this.form.id = router.currentRoute.params.id;
      const form = this.form
      this.$store.dispatch('Feature/getFeature', form).then(async res => {
        let feature = res.data.data
        this.form.type = await feature.type
        this.form.name = await feature.name
        this.form.public_name = await feature.public_name
        this.form.feature_attributes = await feature.feature_attributes
      }).catch(err => {
        console.log(err)
        router.push({name: 'Feature'})
      })

    }
  }
};

</script>

<style scoped></style>